import React, { useSyncExternalStore } from 'react'
import { hasInitialLoadingCover, subscribeToInitialLoading } from './initialLoading'

export const BreakwaterLoader = ({ className = '', style }) => {
  const initialLoading = useSyncExternalStore(subscribeToInitialLoading, hasInitialLoadingCover, hasInitialLoadingCover)
  // Chrome restarts the shared SVG animation when another image instance mounts.
  // The HTML cover owns the only wave image until the first page is revealed.
  if (initialLoading) return null
  return (
    <img
      className={`bw-loading-mark ${className}`}
      src={`${process.env.PUBLIC_URL || ''}/brand/breakwater-ink-tide-slow-navy.svg`}
      width="144"
      height="120"
      alt=""
      aria-hidden="true"
      style={style}
    />
  )
}

const LoadingState = ({ fullScreen = false, label = 'Loading…', className = '' }) => (
  <div
    className={`bw-loading-state${fullScreen ? ' bw-loading-state--fullscreen' : ''} ${className}`}
    data-app-loading={fullScreen || className.split(/\s+/).includes('bw-loading-state--page') ? '' : undefined}
    role="status"
    aria-live="polite"
  >
    <BreakwaterLoader />
    <span className="bw-loading-label">{label}</span>
  </div>
)

export default LoadingState
